export const types = {
  MARK_TASK: 'missions/grid/mark_task',
  SET_LOADING: 'missions/grid/set_loading',
  SET_MISSIONS: 'missions/grid/set_missions',
  SET_SOLDIERS: 'missions/grid/set_soldiers',
  SET_ABSENTEES: 'missions/grid/set_absentees',
}

export const setLoading = ( type, loading ) => {
  return {
    type: types.SET_LOADING,
    payload: { type, loading }
  }
};

export const setMissions = ( type, missions ) => {
  return {
    type: types.SET_MISSIONS,
    payload: { type, missions }
  }
};

export const setSoldiers = ( type, soldiers, date ) => {
  return {
    type: types.SET_SOLDIERS,
    payload: { type, soldiers, date }
  }
};

export const markTask = ( type, user_ids, grid_id, date, mark ) => {
  return {
    type: types.MARK_TASK,
    payload: { type, user_ids, grid_id, date, mark }
  }
};

export const setAbsentees = ( type, absent_ids ) => {
  return {
    type: types.SET_ABSENTEES,
    payload: { type, absent_ids }
  }
};



// WEBPACK FOOTER //
// ./src/store/missions/grid/actions.js